<template>
  <base-modal-ex :active.sync="isActive"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="60"
    has-modal-card>
    <header class="modal-card-head">
      <p class="modal-card-title"
        :class="{ 'is-flex-items-center' : showIcon}">
        <span v-if="showIcon"
          class="icon is-medium"
          :class="`has-text-${iconType}`"
          style="margin-right: 0.5rem">
          <i class="mdi mdi-36px"
            :class="`${iconName}`" />
        </span>
        <span>Send Email</span>
      </p>
    </header>
    <section class="modal-card-body">
      <slot name="text-content" />
      <!-- <vue-email :to-emails="toEmails"
        :cc-emails="ccEmails"
        :bcc-emails="bccEmails"></vue-email> -->
    </section>
    <footer class="modal-card-foot">
      <div :style="`width: 100%; display: flex; justify-content: space-between;`">
        <div style="align-self: flex-start;">
          <button v-if="false"
            class="button tooltip is-tooltip-topleft"
            @click="attach()"
            data-tooltip="Attach media">
            <span class="icon">
              <i class="mdi mdi-paperclip mdi-18px" />
            </span>
          </button>
        </div>
        <div style="align-self: flex-end;">
          <button class="button is-primary tooltip is-tooltip-topright"
            v-show="!toggleAttachButton"
            @click="send()"
            data-tooltip="Send Email"
            :disabled="!enableSend">
            <span class="icon">
              <i class="mdi mdi-send mdi-18px" />
            </span>
            <span>Send</span>
          </button>
          <div class="dropdown"
            :class="{ 'is-active': showAttachDropdown }"
            style="display: inline-block;">
            <button class="button is-primary tooltip"
              v-show="enableAttach"
              @click="toggleAttachDropdown"
              :data-tooltip="[!toggleAttachButton ? 'Attach' : 'Done']"
              :disabled="!enableAttach">
              <span v-if="!toggleAttachButton"
                class="icon is-small">
                <i class="mdi mdi-18px mdi-paperclip" />
              </span>
              <span v-else>Done</span>
            </button>
            <div class="dropdown-menu"
              role="menu"
              style="left: -120px; right: auto; top: auto; bottom: 100%; transform: translateY(-8px);">
              <div style="position: absolute; left: 130px; bottom: -8px; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-top: 8px solid #fff; z-index: 2;" />
              <div class="dropdown-content">
                <a class="dropdown-item"
                  @click="attachImages">
                  <span class="icon">
                    <i class="mdi mdi-image-multiple" />
                  </span>
                  Images
                </a>
                <a class="dropdown-item"
                  @click="attachDocs">
                  <span class="icon">
                    <i class="mdi mdi-file-document-outline" />
                  </span>
                  Documents
                </a>
              </div>
            </div>
          </div>
          <button class="button tooltip is-tooltip-topright"
            v-show="!toggleAttachButton"
            @click="discard()"
            data-tooltip="Discard Email">
            <span class="icon">
              <i class="mdi mdi-delete mdi-18px" />
            </span>
          </button>
        </div>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'

export default {
  name: 'VueEmailModal',
  components: {
    BaseModalEx
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    },
    buttonLocation: {
      type: String,
      default: 'end' // valid values 'start' & 'end'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    iconType: {
      type: String,
      default: 'warning'
    },
    iconName: {
      type: String,
      default: 'mdi-alert-decagram'
    },
    toEmails: {
      type: Array,
      default: () => []
    },
    ccEmails: {
      type: Array,
      default: () => []
    },
    bccEmails: {
      type: Array,
      default: () => []
    },
    enableSend: {
      type: Boolean,
      default: false
    },
    enableAttach: {
      type: Boolean,
      default: true
    },
    toggleAttachButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      allowedImageExtensions: ['.jpg', '.jpeg', '.png'],
      allowedDocumentExtensions: ['.pdf'],
      showAttachDropdown: false
    }
  },
  computed: {},
  watch: {
    active(value) {
      this.isActive = value
    }
  },
  mounted() {
    this.isActive = this.active || false
  },
  methods: {
    send() {
      this.$emit('send')
    },
    attach() {
      this.$emit('show-attach')
    },
    discard() {
      this.isActive = false
      this.$emit('update:active', false)
      this.$emit('discard')
    },
    toggleAttachDropdown() {
      // If the toggleAttachButton is true, it means "Done" button is showing
      if (this.toggleAttachButton) {
        // Emit event to close both image and document selectors
        this.$emit('done-attach')
        this.showAttachDropdown = false
        return
      }
      this.showAttachDropdown = !this.showAttachDropdown
    },
    attachImages() {
      this.$emit('show-attach')
      this.showAttachDropdown = false
    },
    attachDocs() {
      // this.$emit('show-attach')
      this.$emit('attach-docs')
      this.showAttachDropdown = false
    },
    attachFiles() {
      // Trigger the hidden file input
      this.$refs.fileInput.click()
      this.$refs.fileInput.accept = this.allowedImageExtensions.join(',') + ',' + this.allowedDocumentExtensions.join(',')
      // Do NOT close the dropdown here; let onFileChange handle it
    },

    onFileChange(event) {
      const files = event.target.files
      //this.$emit('show-attach')
      this.$emit('attach-files', files)
      this.showAttachDropdown = false // Close dropdown after file selection
    }
  }
}
</script>

<style lang="scss" scoped>
.is-flex-items-center {
  display: flex;
  align-items: center;
}
</style>
